import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          {/* Navigation columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div>
              <h5 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Shop</h5>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <div className="flex flex-col gap-2.5">
                {["Shoes", "Bags", "Accessories", "Perfumes"].map((item) => (
                  <a
                    key={item}
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h5 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Guides</h5>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <div className="flex flex-col gap-2.5">
                {["How To Use", "Safety", "Reviews", "Comparison"].map((item) => (
                  <Link
                    key={item}
                    to="/hipobuy-spreadsheet-guide"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h5 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Compare</h5>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <div className="flex flex-col gap-2.5">
                {["vs Kakobuy", "vs CSSBuy", "vs Superbuy", "vs Oopbuy"].map((item) => (
                  <span key={item} className="text-sm text-foreground-400 cursor-default">
                    {item}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <h5 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Company</h5>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <div className="flex flex-col gap-2.5">
                {["About", "Contact", "Privacy Policy", "Terms", "Disclaimer"].map((item) => (
                  <span key={item} className="text-sm text-foreground-400 cursor-default">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-14 md:mt-16 pt-8 border-t border-background-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <p className="font-heading text-3xl font-extrabold text-foreground-950">Hipobuy</p>
              <p className="font-heading text-3xl font-light text-foreground-600 -mt-1">Spreadsheet</p>
              <div className="w-10 h-px bg-foreground-800 mt-3 mb-2"></div>
              <p className="text-xs text-foreground-500">© 2026 Hipobuy Spreadsheet Hub. All rights reserved.</p>
            </div>
            <div className="flex items-center gap-4">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-pinterest-line", "ri-reddit-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:text-primary-500 hover:border-primary-400 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
          <p className="mt-6 text-center text-[10px] text-foreground-400">
            All external store links open in new tabs with noopener nofollow.
          </p>
        </div>
      </div>
    </footer>
  );
}